<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" pageNumber="pageNumber" />
		</section>
		<div class="basis-cls_table">
			<div class="header">
				<span class="title el-icon-document"> 数据列表</span>
			</div>
			<table-pagination
			ref="tableItem"
			:data="data"
			:column="column"
            v-loading="loading">
				<template v-slot:action="{row}">
					<div class="operate-inline">
						<el-button type="text" size="small" @click="onAddEdit(row)" v-show="!isEleShow(row)">新增</el-button>
						<el-button type="text" size="small" @click="onAddEdit(row)" v-show="isEleShow(row)">修改</el-button>
						<el-divider direction="vertical" v-if="isEleShow(row)"></el-divider>
						<el-button type="text" size="small" @click="onDelete(row)" v-show="isEleShow(row)">删除</el-button>
						<el-divider direction="vertical" v-if="isEleShow(row)"></el-divider>
						<el-button type="text" size="small" @click="onApply(row)" v-show="isEleShow(row)">应用到其他技能组</el-button>
					</div>
				</template>
			</table-pagination>
		</div>
		<!-- 新增编辑框 -->
		<addEdit ref="addEdit" @getList="getList"/>
		<!-- 应用到其他技能组 -->
		<ApplySkillgroup ref="applySkillgroup" :current_row="current_row" @getList="getList"/>
	</div>
</template>

<script>
	import poverTable from './poverTable';
	import addEdit from './addEdit';
	import ApplySkillgroup from './applySkillgroup';
	export default {
		components:{
			poverTable,
            addEdit,
			ApplySkillgroup
		},
		data(){
			return {
				
				listQuery:{
					brand:this.$store.state.user.brandId,
					skillGroup:'',
					pageNumber:1,
					pageSize:10,
                    // childBrand:''
				},
				filterHeader:[
					// { label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
					{ label: '技能组', model: 'skillGroup', type: 'select', default: '', list: []},
				],
				total:0,
				data:[],
				loading:false,
				current_row:'',
				column:[
					// { label: "技能组标识", prop: "groupId" },
					{ label: "技能组名称", prop: "skillGroup" },
					{
						label: "工作时间（个）",
						prop: "workdayCount" ,
						component:poverTable
					},
					{
						label: "节假日时间（个）", 
						prop: "holidayCount" ,
						component:poverTable
					},
					{
						label: '特殊时间（个）',
						prop: 'specialCount',
						component:poverTable
					},
					{
						label: "操作",
						prop: "action",
						align: "center",
						slotScope:true,
						width: 240,
						fixed:'right',
					}
				]
			}
		},
		methods:{
			filterSearch(query){
				this.listQuery = Object.assign(this.listQuery, query);
				this.getList();
			},
			onApply(row){
				this.$refs.applySkillgroup.openApply();
				this.current_row = Object.assign({},row);
			},
			onAddEdit(row){
				this.$refs.addEdit.onShow(row);
			},
			isEleShow(row){
				if(row.workdayCount > 0 || row.holidayCount > 0 || row.specialCount > 0){
					return true
				}
				return false
			},
			onDelete(row){
				this.$confirm("删除后将清空时间策略，系统默认该技能组为闭线状态", `确认要删除该技能组的时间策略吗？`, {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "error",
						center: true,
						customClass: "confirm-element-model"
					})
					.then(() => {
						this.$api.apiDeleteTelSkillgroupForSystem({
							brand:this.$store.state.user.brandId,
							skillGroup:row.skillGroup
						}).then(res => {
							if(res.errcode != 0) return;
							this.$message.success('取消删除');
							this.getList()
						})
						
					})
					.catch(() => {
						this.$message.info('取消删除')
					});
			},
			
			getList(){
				this.loading = true
				this.$api.apiGetTelLineMangerForSystem(this.listQuery).then(res => {
					this.loading = false
					if(res.errcode != 0) return;
						this.data = res.data;
				})
			},
			
	        getSkillGroup(){
                this.$api.apiGetTelSkillgroupForSystem({projectCode: this.$store.state.user.brandId}).then(response => {
                    for(const item of response.data) {
                        this.filterHeader[0]['list'].push({
                            id: item.groupId,
                            name: item.queueName
                        });
                    }
                });
            }
			
		},
		async created() {
			await this.getList();
			await this.getSkillGroup();
		}
	}
</script>
